import React, { useEffect } from 'react';
import { WebFooterStyle } from './style';

const WebFooter = () => {
  return (
    <WebFooterStyle>
      <div className="content">
        <img className="logo" src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/yun/yun-logo.png" />
        <ul className="enter-list">
          <li>
            <a href="https://www.yowant.com/">遥望官网</a>
          </li>
          <li>
            <a href="https://srm-supplier.ywwl.com/" target="blank">
              遥望云链
            </a>
          </li>
          <li>
            <a href="https://yun.ywwl.com/visitorOrder/DM4BD8D1870675055012681037855126/_visitorOrder_visitorOrder" target="blank">
              访客预约
            </a>
          </li>
          {/* <li>
            <a href="https://www.ywwl.com/anti.html">找人地图</a>
          </li> */}
        </ul>
        <ul className="contact-list">
          <li>总台电话：0571-88515356</li>
          <li>廉政邮箱：lianzheng@ywwl.com</li>
          <li>廉政举报：15227172657</li>
          <li>公司地址：浙江省杭州市余杭区良睦路与向往街交叉口蔚蓝中心1号楼遥望直播电商产业园</li>
        </ul>
        {/* <div className="qr-box">
          <img className="qc-img" src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/yun/question-code.png" />
          <div>产品问题反馈群</div>
        </div>
        <div className="qr-box">
          <img className="qc-img" src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/yun/production-code.png" />
          <div>产品反馈群</div>
        </div> */}
      </div>
      <div className="bottom-copyright">
        <div>违法和不良信息公开举报电话：0571-88579752</div>
        <div style={{marginTop: '12px'}}>©2010-2023 杭州遥望网络科技有限公司 版权所有 浙B2-20150248 浙公网安备 33011002010213号</div>
      </div>
    </WebFooterStyle>
  );
};

export default WebFooter;
